export const datiRiscossioneSpecificiConst = [
  { label: "Contributo unificato", value: "CONTRIB" },
  { label: "Diritti di cancelleria", value: "DIRCANC" },
  { label: "Diritti di Copia", value: "DIRCOPIA" },
  { label: "Contributo Unificato richiesta ricerca beni ex art 492 bis", value: "CONTRBENI" },
  { label: "Pignoramenti uffici NEP o richiesta ricerca beni ex art 492 bis comma 1", value: "UNPIG" },
  { label: "Notifiche uffici NEP", value: "UNNOT" }
];
